"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'UserList',
  filters: {
    sexFilter: function sexFilter(status) {
      var statusMap = {
        0: '未知',
        1: '男',
        2: '女',
        3: '保密'
      };
      return statusMap[status];
    },
    statusFilter: function statusFilter(status) {
      var statusMap = {
        wechat: '微信用户',
        routine: '小程序用户'
      };
      return statusMap[status];
    }
  },
  data: function data() {
    return {
      templateRadio: 0,
      loading: false,
      tableData: {
        data: [],
        total: 0
      },
      userFrom: {
        payCount: '',
        sex: '',
        identity: '',
        registerType: '',
        page: 1,
        limit: 20,
        searchType: 'all',
        content: ''
      },
      // userFrom: {
      //   payCount: '',
      //   sex: '',
      //   identity: '',
      //   registerType: '',
      //   page: 1,
      //   limit: 20,
      //   searchType: 'all',
      //   content: '',
      // },
      keywords: ''
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getTemplateRow: function getTemplateRow(idx, row) {
      this.$emit('getTemplateRow', row);
    },
    // 列表
    getList: function getList(num) {
      var _this = this;
      this.loading = true;
      this.userFrom.page = num ? num : this.userFrom.page;
      (0, _user.userListApi)(this.userFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.loading = false;
      }).catch(function (res) {
        _this.$message.error(res.message);
        _this.loading = false;
      });
    },
    search: function search() {
      this.getList(this.keywords);
    },
    pageChange: function pageChange(page) {
      this.userFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.userFrom.limit = val;
      this.getList();
    }
  }
};